// @ts-nocheck
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getDashboardTitle } from '../utils/dashboardTitle';
import DashboardUserProfile from './DashboardUserProfile';
import { usePageActions } from '../contexts/PageActionsContext';

export default function DashboardTopNav({
  profileFullName,
  profileSeniority,
  profileJobTitle,
  profileCompany,
  accountCtx,
  roles,
  onLogout,
  logoutBusy,
}) {
  const { pathname } = useLocation();
  const title = useMemo(() => getDashboardTitle(pathname), [pathname]);
  const { pageActions } = usePageActions();

  return (
    <header className="dashboard-topnav d-flex align-items-center px-3 px-lg-4 py-2 border-bottom border-secondary-subtle bg-body flex-shrink-0 shadow-sm gap-2">
      <div className="d-flex align-items-center gap-2 min-w-0 flex-shrink-0">
        {title ? (
          <h1 className="h5 mb-0 text-body text-truncate">{title}</h1>
        ) : null}
      </div>
      {/*
        Page-actions area: pages register compact action buttons via
        usePageActions().setPageActions(...). They render inline with the
        title, never as a separate band, so the topnav stays a single
        fixed-height row.
      */}
      <div className="dashboard-topnav-actions d-flex align-items-center gap-2 min-w-0 flex-grow-1">
        {pageActions}
      </div>
      <DashboardUserProfile
        compactAvatar
        fullName={profileFullName}
        seniority={profileSeniority}
        jobTitle={profileJobTitle}
        company={profileCompany}
        accountCtx={accountCtx}
        roles={roles}
        onLogout={onLogout}
        logoutBusy={logoutBusy}
      />
    </header>
  );
}
